import Axios from 'axios'
import Vue from 'vue'
import { message} from 'ant-design-vue'
Vue.prototype.$message = message;
import configPort from './common.js'
Axios.defaults.withCredentials = true

const service = Axios.create({
	baseURL: configPort.host,
	headers: {
		'Accept': 'application/json'
	},
	timeout: 20000 
})

service.interceptors.request.use(config => {
	// let token = localStorage.getItem('token')
	// config.headers['Token'] = token
	return config
}, error => {
	Promise.reject(error)
})

service.interceptors.response.use(response => {
	const res = response
	if (res.data.code !== 200 && res.status !== 200) {
	  message.error('服务器异常');
	  return Promise.reject('error')
	}
	return response
}, error => {
	if(error.request.status==401){
	  message.error("登录已经失效!")
	}else{
		message.error(error.message)
		return Promise.reject('error')
	}
})

export default service